import { queries } from "./global.queries";
import { selectors } from "./global.selectors";
import { actions } from "./global.actions";

export const global = {
  actions: actions,
  selectors: selectors,
  queries: queries,
};
